import { amplitude, ga } from 'js/analytics/adapters'
import { baseWebEventProps } from 'js/analytics/standardizedProps'

export const trackLogin = ({ method: login_method }) => {
  ga.track('log_in', { login_method })
  amplitude.track('user_login_web', {
    ...baseWebEventProps(),
    action_name: 'login',
    action_type: 'active',
    authentication_method: login_method,
  })
}
